export default __webpack_public_path__ + "static/media/2020-interior-2.52bcfd7c.jpeg";